import { render, staticRenderFns } from "./EditConfigDobleFactorPorUsuario.vue?vue&type=template&id=7f610eb0"
import script from "./EditConfigDobleFactorPorUsuario.vue?vue&type=script&lang=js"
export * from "./EditConfigDobleFactorPorUsuario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports